import React from 'react';
import './news.css';

const newsItems = [
    {
        date: '2026/06',
        content: (
            <>
                Deform360 is accepted to ECCV 2026, and will be presented in Malmö, Sweden.
            </>
        ),
    },
    {
        date: '2026/06',
        content: (
            <>
                UniTac received {' '}
                <a href="https://sense-of-space.github.io/" target="_blank" rel="noreferrer">
                Outstanding Paper Award </a>at the CVPR 2026
                
                    Sense of Space (SOS)
                
                workshop.
            </>
        ),
    },
    {
        date: '2026/05',
        content: (
            <>
                I graduated from Brown University with <em>honors</em> in Sc.B. Computer
                Science and A.B. Applied Maths, <em>senior prize</em>, and <em>magna cum laude</em>.
            </>
        ),
    },
    {
        date: '2025/10',
        content: (
            <>
                I received {' '}
                <a href="https://cra.org/about/awards/outstanding-undergraduate-researcher-award/" target="_blank" rel="noreferrer">
                Computing Research Association (CRA) Outstanding Undergraduate Researcher Award
                </a> honorable mention.
            </>
        ),
    },
    {
        date: '2025/06',
        content: (
            <>
                I received {' '}
                <a href="https://sites.google.com/lehigh.edu/pathways-rss2025/fellows?authuser=0" target="_blank" rel="noreferrer">
                Pathways@RSS 2025 Fellowship
                </a> (<strong>8%</strong> accepted).
            </>
        ),
    },
    {
        date: '2025/04',
        content: (
            <>
                I received  {' '}
                <a href="https://cs.brown.edu/news/2025/11/18/wanjia-fu-uses-her-randy-f-pausch-82-computer-science-undergraduate-summer-research-award-to-help-robots-perceive-through-touch/" target="_blank" rel="noreferrer">
                Randy Pausch Undergraduate Research Fellowship
                </a> from Brown University (<strong>top 1</strong>).
            </>
        ),
    },
    {
        date: '2024/11',
        content: (
            <>
                GigaHands is accepted to CVPR 2025 as a{' '}
                <span className="news__highlight">Highlight Paper</span>.
            </>
        ),
    },
    
];

const News = () => {
    return (
        <section className="news section">
            <div className="news__container container">
                <h2 className="section__title" id="news">News</h2>
                <ul className="news__list">
                    {newsItems.map((item) => (
                        <li key={item.date} className="news__item">
                            <span className="news__date">{item.date}</span>
                            <p className="news__content">{item.content}</p>
                        </li>
                    ))}
                </ul>
            </div>
        </section>
    );
};

export default News;
